module.exports = __webpack_public_path__ + "img/gb9113_13_a.prt.be50c96d.jpg";